import styled from 'styled-components';
import { theme } from 'styled-tools';
const MainWrapper = styled.div<{ bgWhite?: boolean }>`
  background-color: ${({ bgWhite }) => (bgWhite ? theme('colors.white') : theme('colors.blue'))};
  width: 100%;
`;

export { MainWrapper };
